export const data = {
  categories: [
    {
      id: 2,
      title: 'Physics',
      desc: '',
      introVideo: 'https://youtu.be/KrybkCB5qTk',
      user: ['a Highschool', 'b Highschool'],

      subcategories: [
        {
          id: 1,
          title: 'Current Electricity',
          desc: '',
          videoURL: 'https://youtu.be/6AyfRlpFMU0',
          user: ['a Highschool', 'b Highschool', 'c Highschool', 'd Highschool'],

          videos: [
            
            {
              id: 1,
              title: 'Sources of current Electricity',
              description: 'In this video, you will learn about the various sources of current electricity.',
              url: 'https://youtu.be/YUfSVlxtuIs',
            },
            {
              id: 2,
              title: 'Ohm’s law',
              description: "In this video simulation, you will learn about Ohm's law, which relates voltage, current, and resistance in the circuit.",
              url: 'https://youtu.be/l72qCV4ccFU',
              user: ['k', 'd'],
            },

            {
              id: 3,
              title: 'Simulation of simple electric circuit',
              description: 'In this video simulation, you will learn about a simple electric circuit and its components.',
              url: 'https://youtu.be/hcm0vJ5bIZs',
              user: ['k', 'd'],
            },

            {
              id: 4,
              title: 'Simulation of voltage measurement',
              description: 'In this video simulation, you will learn how to connect the voltmeter correctly to measure voltage in the circuit.',
              url: 'https://youtu.be/GNIQ9UE3K7Q',
              user: ['k', 'd'],
            },

            {
              id: 5,
              title: 'Simulation of current measurement',
              description: 'In this video simulation, you will learn how to connect the ammeter correctly to measure the current in the circuit.',
              url: 'https://youtu.be/smex_rZA6iI',
              user: ['k', 'd'],
            },

            {
              id: 6,
              title: 'Simulation of circuit with series-parallel arrangement of resistors',
              description: 'In this video simulation, you will learn the functionality of circuits with either series or parallel combinations of resistors.',
              url: 'https://youtu.be/JKvQTCRLTHY',
              user: ['k', 'd'],
            },

            {
              id: 7,
              title: 'Calculation of total resistance in a series circuit',
              description: 'In this video simulation, you will learn how to calculate the total resistance in the circuit with resistors arranged in series.',
              url: 'https://youtu.be/rjhsk2JWLJQ',
              user: ['k', 'd'],
            },
            {
              id: 8,
              title: 'Calculation of total resistance in a parallel circuit',
              description: 'In this video simulation, you will learn how to calculate the total resistance in the circuit with resistors arranged in parallel.',
              url: 'https://youtu.be/iZmN1HA3kp0',
              user: ['k', 'd'],
            },

            {
              id: 9,
              title: 'What to consider to light a simple LED',
              description: 'In this theoretical video, you will learn important things and concepts to consider for the LED circuit to work properly.',
              url: 'https://youtu.be/6AyfRlpFMU0',
              user: ['k', 'd'],
            },

            {
              id: 10,
              title: 'How the breadboard works',
              description: 'In this video, you will learn how the breadboard works so you can understand the practical demonstrations in the videos that follow.',
              url: 'https://youtu.be/DdBr3LlZ8Bs',
              user: ['k', 'd'],
            },
            {
              id: 11,
              title: 'Practical measurement of voltage and current in the circuit',
              description: 'In this video, you will learn how to measure voltage and current in the circuit in a live demonstration.',
              url: 'https://youtu.be/1F_eliK27vw',
              user: ['k', 'd'],
            },
            {
              id: 12,
              title: 'How a change of resistance affects current flow in the circuit',
              description: 'In this video, you will learn how current decreases with the increase of resistance. Resistance is varied from 220, 330, 1K, and 10K, and a decrease of current is observed correspondingly, proving ohms law.',
              url: 'https://youtu.be/hartkLkXY2I',
              user: ['k', 'd'],
            },
            {
              id: 13,
              title: 'Practical measurement of resistance in series parallel combination',
              description: 'In this video, you will learn how to practically measure total resistance in a series-parallel combination.',
              url: 'https://youtu.be/CVvIjrz2Lqg',
              user: ['k', 'd'],
            },
            {
              id: 14,
              title: 'Practical measurement of current in series parallel combination',
              description: 'In this video, you will learn practically how current is affected when resistors are combined in series or parallel.',
              url: 'https://youtu.be/VixW5g53sYI',
              user: ['k', 'd'],
            },

          ],
        },

      ],

    }
  ]
}